import fileDownload from 'js-file-download'
import axios from 'axios'

export const printDocument = (url) => {
  axios
    .get(url, {
      responseType: 'blob',
    })
    .then((res) => {
      var blobURL = URL.createObjectURL(res.data)
      let iframe = document.createElement('iframe') //load content in an iframe to print later
      document.body.appendChild(iframe)

      iframe.style.display = 'none'
      iframe.src = blobURL
      iframe.onload = function () {
        setTimeout(function () {
          iframe.focus()
          iframe.contentWindow.print()
        }, 1)
      }
    })
}

export const downloadDocument = (url) => {
  axios
    .get(url, {
      responseType: 'blob',
    })
    .then((res) => {
      fileDownload(res.data, url.split('/').pop())
    })
}
